export default __webpack_public_path__ + "static/media/amp.10580736.png";